import React from 'react';

interface Props {
    className?: string;
    presignedUrl?: string;
    selectedFile?: File;
    type?: string;
}

interface State {
    fileUrl?: string;
}

class Media extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount(): void {
        this.buildFileUrl();
    }

    componentDidUpdate(prevProps: Props): void {
        if (prevProps.selectedFile != this.props.selectedFile) {
            this.buildFileUrl();
        }
    }

    buildFileUrl(): void {
        if (this.props.selectedFile) {
            // Making a copy of the blob only clones the metadata, the actual bytes are read from file each time
            const blob = new Blob([this.props.selectedFile], { type: this.props.selectedFile.type });
            this.setState({ fileUrl: URL.createObjectURL(blob) });
        } else {
            this.setState({ fileUrl: this.props.presignedUrl });
        }
    }

    render(): JSX.Element {
        const imageStyle = {
            height: 'auto',
            maxWidth: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
            padding: '15px',
            display: 'block',
        };
        return (
            <div className={this.props.className || ''}>
                {this.props.type === 'AUDIO' && this.state.fileUrl && (
                    <audio controls crossOrigin="anonymous" src={this.state.fileUrl}>
                        audio file
                    </audio>
                )}
                {this.props.type === 'IMAGE' && this.state.fileUrl && (
                    <a href={this.state.fileUrl} target="_blank" rel="noreferrer">
                        <img
                            crossOrigin="anonymous"
                            alt="S3 Image not found"
                            style={imageStyle}
                            src={this.state.fileUrl}
                        />
                    </a>
                )}
            </div>
        );
    }
}

export default Media;
